module.exports = __webpack_public_path__ + "static/media/34_KenanDemir_webfinal.36b3edee.jpg";